import { render, staticRenderFns } from "./CheckedCustomCartIcon.vue?vue&type=template&id=d5fa2dc0"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports